<script setup lang="ts">
import { cva, VariantProps } from 'class-variance-authority'
import { toRefs } from 'vue'

import AmazonLogo from './AmazonLogo.vue'
import MerchantName from './MerchantName.vue'
import GolfGuenstigLogo from './GolfGuenstigLogo.vue'

const logoVariants = cva('absolute top-1/2 -translate-y-1/2', {
  variants: {
    size: {
      md: 'max-h-[1.5rem] max-w-[4rem]',
      lg: 'max-h-[1.75rem] max-w-[5.2rem]'
    }
  }
})

const logoContainerVariants = cva('relative', {
  variants: {
    size: {
      md: 'min-h-[1.5rem] min-w-[4rem]',
      lg: 'min-h-[1.75rem] min-w-[5.2rem]'
    }
  }
})

type PurchaseOptionLogoProps = VariantProps<typeof logoVariants>

const props = withDefaults(
  defineProps<{
    merchant: { name: string, logoUrl?: string }
    variant?: string | null
    size?: PurchaseOptionLogoProps['size']
  }>(),
  {
    variant: 'primary',
    size: 'lg'
  }
)

const { merchant, variant, size } = toRefs(props)
</script>

<template>
  <div :class="logoContainerVariants({size})">
    <AmazonLogo v-if="merchant.name === 'Amazon'"
                :class="logoVariants({size})"
                :white="variant === 'highlighted'" />
    <GolfGuenstigLogo v-else-if="merchant.name === 'Golf und Günstig DE'"
                      :white="variant === 'highlighted'"
                      :class="logoVariants({size})" />
    <img v-else-if="merchant.logoUrl"
         :class="logoVariants({size})"
         :src="merchant.logoUrl"
         :alt="merchant.name!"
         :title="`Logo of ${merchant.name}`">
    <MerchantName v-else-if="merchant.name"
                  :variant="variant"
                  :size="size"
                  :name="merchant.name" />
  </div>
</template>
